module.exports = __webpack_public_path__ + "assets/img/player_play.24944768.png";